import api from 'api';

const url = '/api/notifications';

export default {
    get: () => api.get({path: url})
}